import {
    Checkbox,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    ListItem,
    makeStyles,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@material-ui/core"
import { AddAPhoto } from "@material-ui/icons"
import { useSnackbar } from "notistack"
import { useRef } from "react"
import { redimensionarPara300x300 } from "../../../functions/imagens"
import { inativarOpcao, inativarProduto } from "../../../services/cardapio"
import useAppStore from "../../../stores/AppStore"
import useLoadingStore from "../../../stores/LoadingStore"
import { useCheckboxContext } from "./CheckboxContext"
import DisponibilidadeSwitch from "./DisponibilidadeSwitch"

const useStyles = makeStyles(() => ({
    containerImg: {
        margin: "auto",
        maxWidth: "100px",
        height: "100px",
        backgroundColor: "#eee",
        border: "2px dashed #ccc",
        cursor: "pointer",
        overflow: "hidden",
        borderRadius: "10px",
    },
    addAPhoto: {
        width: "40%",
        height: "40%",
        color: "rgba(0,0,0,0.5)",
    },
    textoImg: {
        color: "rgba(0,0,0,0.5)",
    },
    input: {
        display: "none",
    },
    textos: {
        fontWeight: "bold",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%",
    },
}))

export default function ItemMassa({
    index,
    produto,
    handleInputChange,
    handleCadastrarImagem,
    setItems,
    estabelecimento,
}) {
    const autorizacao = localStorage.getItem("chaveSistema")
    const setLoading = useLoadingStore(s => s.setLoading)
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const configs = useAppStore(s => s.configuracoes)
    const parametros = configs.user.parametros

    const item = produto

    const fileInputRef = useRef(null)
    const handleDivClick = () => {
        fileInputRef.current.click()
    }

    const handleFileChange = async event => {
        const file = event.target.files[0]
        if (!file) return

        try {
            const file300 = await redimensionarPara300x300(file)
            const nomeArquivo = file.name
            const idProduto = item.tipo === "P" ? produto.id : item.produto
            const idOpcao = item.tipo === "O" ? produto.id : null
            const idPasso = null
            const edicaoMassa = true

            const response = await handleCadastrarImagem(
                nomeArquivo,
                idProduto,
                idPasso,
                idOpcao,
                file300,
                edicaoMassa
            )

            setItems(prev => {
                const newItems = [...prev]
                if (item.tipo === "P") {
                    newItems[index].urlImagemProduto = response
                } else {
                    newItems[index].urlImagemOpcao = response
                }
                return newItems
            })
        } catch (error) {
            alertStart(`${error}`, "error")
        }
    }

    const classes = useStyles()

    const { checkedItems, toggleItem } = useCheckboxContext()
    const checked = checkedItems[item.id] || false

    const handleChangeCodigoPDV = e => {
        item.codigoPDV = e.target.value
    }

    const handleChangeDisponibilidadeProduto = async () => {
        setLoading(true)
        const response = await inativarProduto(item?.id, item?.ativo, autorizacao)
        if (response.retornoErro) {
            console.error(response)
            alertStart(response.mensagem, "error")
        } else {
            item.ativo = !item.ativo
            alertStart("Disponibilidade do produto alterada com sucesso", "success")
        }
        setLoading(false)
    }

    const handleChangeDisponibilidadeOpcao = async () => {
        setLoading(true)
        const response = await inativarOpcao(item?.id, item?.ativo, autorizacao)
        if (response.retornoErro) {
            console.error(response)
            alertStart(response.mensagem, "error")
        } else {
            item.ativo = !item.ativo
            alertStart("Disponibilidade da opção alterada com sucesso", "success")
        }
        setLoading(false)
    }

    return (
        <ListItem key={item?.id} divider>
            <Grid>
                <Checkbox color="primary" onChange={() => toggleItem(item?.id)} checked={checked} />
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
                <Grid xs={12} sm={12} md={4} item container alignItems="center" spacing={1}>
                    <Grid
                        className={classes.containerImg}
                        item
                        container
                        justifyContent="center"
                        alignItems="center"
                        onClick={handleDivClick}
                        xs={12}
                        sm={6}
                        md={4}
                    >
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                        >
                            {!item.urlImagemProduto && !item.urlImagemOpcao ? (
                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <AddAPhoto className={classes.addAPhoto} />
                                </Grid>
                            ) : (
                                <img
                                    loading="lazy"
                                    style={{
                                        borderRadius: "10px",
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: "center",
                                    }}
                                    src={
                                        item.tipo === "P"
                                            ? item.urlImagemProduto
                                            : item.urlImagemOpcao
                                    }
                                    alt="Uploaded"
                                />
                            )}
                        </Grid>
                        <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            className={classes.input}
                            accept="image/*"
                        />
                    </Grid>
                    <Grid item container xs={12} sm={6} md={8} direction="column">
                        <Typography className={classes.textos}>
                            {item.tipo === "P" ? "Produto" : "Adicional"}
                        </Typography>
                        <Typography style={{ width: "100%" }}>{item.nome}</Typography>
                    </Grid>
                </Grid>
                <Grid xs={12} sm={4} md={6} container justifyContent="center" spacing={1}>
                    <Grid item xs={12} sm={6} md={3}>
                        {item?.tipo === "O" ? (
                            <>
                                <Typography className={classes.textos}>
                                    Passo de Montagem
                                </Typography>
                                <Typography
                                    style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: "100%",
                                    }}
                                >
                                    {item?.grupo?.slice(0, 40)}
                                </Typography>
                            </>
                        ) : (
                            <>
                                <Typography className={classes.textos}>Descrição</Typography>
                                <Typography
                                    style={{
                                        maxWidth: "100%",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                    }}
                                >
                                    {item?.descricao?.slice(0, 40)}
                                </Typography>
                            </>
                        )}
                    </Grid>
                    {parametros.impressaoAlternada && (
                        <Grid item xs={12} sm={6} md={3}>
                            <FormControl
                                fullWidth
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            >
                                <InputLabel>Impressora</InputLabel>
                                <Select
                                    label="Impressora"
                                    defaultValue={item.impressaoAlternada}
                                    onChange={e => (item.impressaoAlternada = e.target.value)}
                                >
                                    <MenuItem value={0}> - </MenuItem>
                                    <MenuItem value={1}> 1ª impressora </MenuItem>
                                    <MenuItem value={2}> 2ª impressora </MenuItem>
                                    <MenuItem value={3}> 3ª impressora </MenuItem>
                                    <MenuItem value={4}> 4ª impressora </MenuItem>
                                    <MenuItem value={5}> 5ª impressora </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={item.impressaoAlternada === 0 || item.impressaoAlternada ? 3 : 4}
                        container
                        direction="column"
                        justifyContent="center"
                    >
                        <TextField
                            type="text"
                            id="codigoPDV"
                            fullWidth
                            variant="outlined"
                            label="Código PDV"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            placeholder="Código PDV"
                            defaultValue={item.codigoPDV}
                            onChange={handleChangeCodigoPDV}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={item.impressaoAlternada === 0 || item.impressaoAlternada ? 3 : 4}
                    >
                        <TextField
                            type="number"
                            id={`inputValorMassa${item.id}`}
                            fullWidth
                            variant="outlined"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">R$</InputAdornment>
                                ),
                            }}
                            inputProps={{
                                style: { textAlign: "right" },
                                placeholder: "0.00",
                            }}
                            label="Preço"
                            value={item.valor}
                            onChange={e => handleInputChange(item.id, e.target.value)}
                        />
                    </Grid>
                </Grid>
                <Grid container xs={12} sm={4} md={2} justifyContent="center">
                    <DisponibilidadeSwitch
                        produto={item.grupo ? false : true}
                        disponivel={item?.ativo}
                        handleChangeDisponibilidadeProduto={handleChangeDisponibilidadeProduto}
                        handleChangeDisponibilidadeOpcao={handleChangeDisponibilidadeOpcao}
                    />
                </Grid>
            </Grid>
        </ListItem>
    )
}
